<template>
  <div class="flex max-w-64 flex-col items-center justify-center text-center">
    <img alt="" src="@/assets/images/ghost.png" />
    <div>
      <h3>Sorry No Data Found</h3>
      <p>
        {{
          body ||
          `There is no data yet. Data is displayed when a prompt has been running for at least two
          hours.`
        }}
      </p>
    </div>
  </div>
</template>

<script setup>
defineProps({ body: { type: String, default: "" } });
</script>
